import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConditionConfig } from '@core/models/built/procedure-step-config.model';
import { ProcedureStep } from '@core/models/procedures.model';
import { FlowchartMode } from '@flowchart';
import { TranslocoService } from '@ngneat/transloco';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import it from './i18n/code-edit.it.json';

@Component({
  templateUrl: './code-edit.component.html',
  styles: ['.code-container { height: 250px; margin: 0 auto;}']
})
export class CodeEditComponent implements OnInit, OnChanges, OnDestroy {

  @Input() step?: ProcedureStep;
  @Input() mode: FlowchartMode = 'edit';
  @Input() editForm!: FormGroup;

  private mode$$ = new BehaviorSubject<FlowchartMode>(this.mode);
  codeEditorOptions$ = this.mode$$.pipe(map(mode => ({
    theme: 'vs-dark',
    language: 'javascript',
    readOnly: mode === 'view'
  })));

  constructor(
    private fb: FormBuilder,
    private translocoSvc: TranslocoService
  ) {
    this.translocoSvc.setTranslation(it, 'it');
  }

  ngOnInit() {
    const config = this.step?.config as ConditionConfig;

    const configGroup = (this.editForm.get('config') as FormGroup);
    if (configGroup) {
      configGroup.addControl('code', this.fb.control(config?.code, [Validators.required]));
    } else {
      this.editForm.addControl('config', this.fb.group({
        code: [config?.code, [Validators.required]]
      }));
    }

    if (this.mode === 'view') {
      (this.editForm.get('config') as FormGroup).disable();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.mode) {
      this.mode$$.next(changes.mode.currentValue);
    }
  }

  ngOnDestroy() {
    const configGroup = (this.editForm.get('config') as FormGroup);

    if (configGroup) {
      configGroup.removeControl('code');

      if (Object.keys(configGroup.controls).length <= 0) {
        this.editForm.removeControl('config');
      }
    }
  }

}
